const {enable, provider} = require('../../config/chat');

let isChatInitialized = false;
let isUserLoggedIn = false;

module.exports.registerChat = async function () {
    if (typeof window !== 'undefined' && enable) {
        let {registerChat} = await import(`./${provider}`);

        await registerChat();
    }
}

module.exports.initChat = async function (context, reinitialize = false) {
    if (typeof window !== 'undefined' && enable) {
        if (!isChatInitialized || reinitialize){
            isChatInitialized = true;

            let {initChat} = await import(`./${provider}`);

            initChat(context);
        }

        if (!isUserLoggedIn){
            isUserLoggedIn = true;

            let {loginUser} = await import(`./${provider}`);

            loginUser(context);
        }
    }
}

module.exports.hideChat = async function (context) {
    if (typeof window !== 'undefined' && enable) {
        let {hideChat} = await import(`./${provider}`);

        hideChat(context);
    }
}

module.exports.showChat = async function (context) {
    if (typeof window !== 'undefined' && enable) {
        let {showChat} = await import(`./${provider}`);

        showChat(context);
    }
}

module.exports.loginUser = async function (context) {
    if (typeof window !== 'undefined' && enable) {
        let {loginUser} = await import(`./${provider}`);

        loginUser(context);
    }
}

module.exports.logoutUser = async function (context) {
    if (typeof window !== 'undefined' && enable) {
        let {logoutUser} = await import(`./${provider}`);

        logoutUser(context);
    }
}

module.exports.maximizeChat = async function (context) {
    if (typeof window !== 'undefined' && enable) {

        if (!isChatInitialized) {
            await this.initChat(context);
        }

        let {maximizeChat} = await import(`./${provider}`);

        maximizeChat(context);
    }
}